import angular from 'angular';

angular
    .module('dematPlatform')

    .factory('DematPlatformService', [
        '$resource',
        'API_CONFIG',
        function($resource, API_CONFIG) {
            var DematPlatform = $resource(API_CONFIG.url + '/v1/demat-platform', {}, {});

            return DematPlatform;
        }
    ]);
